/* eslint-disable */
"use strict";

import QFToggle from "./../../components/toggle.js";
import QFLayoutStickyCard from "./sticky-card.js";
import QFLayoutHeaderMenu from "./header-menu.js";
import QFLayoutAsideMenu from "./aside-menu.js";
import { QFCookie } from "./../../components/cookie.js";
import { QFUtil } from "./../../components/util.js";

var QFLayoutAsideToggle = function() {
    // Private properties
    var _body;
    var _element;
    var _toggleObject;

	// Initialize
	var _init = function() {
		_toggleObject = new QFToggle(_element, _body, {
			targetState: 'aside-minimize',
			toggleState: 'active'
		});

		_toggleObject.on('toggle', function(toggle) {
            // Update sticky card
            if (typeof QFLayoutStickyCard !== 'undefined') {
                QFLayoutStickyCard.update();
            }

            // Pause header menu dropdowns
            if (typeof QFLayoutHeaderMenu !== 'undefined') {
                QFLayoutHeaderMenu.pauseDropdownHover(800);
            }

            // Pause aside menu dropdowns
            if (typeof QFLayoutAsideMenu !== 'undefined') {
                QFLayoutAsideMenu.pauseDropdownHover(800);
            }

            // Remember state in cookie
			QFCookie.setCookie('kt_aside_toggle_state', toggle.getState());
			// to set default minimized left aside use this cookie value in your
			// server side code and add "kt-primary--minimize aside-minimize" classes to
			// the body tag in order to initialize the minimized left aside mode during page loading.
		});

		_toggleObject.on('beforeToggle', function(toggle) {
			if (QFUtil.hasClass(_body, 'aside-minimize') === false && QFUtil.hasClass(_body, 'aside-minimize-hover')) {
				QFUtil.removeClass(_body, 'aside-minimize-hover');
			}
		});
	}

    // Public methods
	return {
		init: function(id) {
            _element = QFUtil.getById(id);
            _body = QFUtil.getBody();

            if (!_element) {
                return;
            }

            // Initialize
            _init();
		},

        getElement: function() {
            return _element;
        },

        getToggle: function() {
			return _toggleObject;
		},

		onToggle: function(handler) {
			if (typeof _toggleObject.element !== 'undefined') {
				_toggleObject.on('toggle', handler);
			}
		}
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = QFLayoutAsideToggle;
}

export default QFLayoutAsideToggle;